import React, { useState, useEffect } from 'react';
import { Row, Col, Select, Spin } from 'antd';
import { PlusSquareOutlined, DownOutlined } from '@ant-design/icons';
import SpiderChart from '../../../../components/Chart/SpiderChart';
import {
	XChartControlsContainer,
	XShieldRightScrollCard,
	XShieldSpiderCard,
} from '../../../ShieldMaxx/ShieldMaxxStyle';
import { XTheme2Button } from '../../../../styles/GlobalThemeStyleCQ';
import { XThemeVASelectButton } from '../../VoiceAssistanceStyle';

const { Option } = Select;

const VAPayerComparisonDetails = ({
	renderPayerDropdowns,
	renderSpiderCards,
	getCurrentChartData,
	// Add new props
	insuranceDropdownOptions,
	onInsuranceDropdownFocus,
	onInsuranceSelection,
	isLoading,
	// Add dropdown value prop
	dropdownValue,
	onDropdownChange,
	// Add bucket loading prop
	isBucketLoading,
}) => {
	const spiderChartData = getCurrentChartData();

	return (
		<>
			<div className="header leftHeaderData">
				<Row gutter={[15, 15]}>
					<Col xs={24} sm={24} md={12} lg={12}>
						Payer Comparison
					</Col>
					<Col xs={24} sm={24} md={12} lg={12} className="text-end">
						{isBucketLoading ? (
							<Spin size="small" />
						) : (
							<>
								<XThemeVASelectButton
									placeholder="Add Payer"
									style={{ width: 'auto' }}
									onFocus={onInsuranceDropdownFocus}
									onChange={onInsuranceSelection}
									loading={isBucketLoading} // Use bucket loading instead of general loading
									disabled={isBucketLoading} // Disable during bucket loading
									value={dropdownValue} // Add controlled value
									notFoundContent={
										isBucketLoading ? (
											<Spin size="small" />
										) : (
											'No insurance companies found'
										)
									}
									suffixIcon={<PlusSquareOutlined />}
									allowClear
									// Let the dropdown size based on content
									dropdownMatchSelectWidth={false}
								>
									{insuranceDropdownOptions.map((option) => (
										<Option
											key={option.value}
											value={option.value}
										>
											{option.label}
										</Option>
									))}
								</XThemeVASelectButton>
							</>
						)}
					</Col>
				</Row>
			</div>
			<div className="">
				<XShieldRightScrollCard className="noCard">
					<XChartControlsContainer className="d-flex flex-wrap align-items-center">
						{renderPayerDropdowns()}
					</XChartControlsContainer>

					<div
						style={{
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							minHeight: '400px',
							padding: '20px',
						}}
					>
						<SpiderChart data={spiderChartData} />
					</div>

					<XShieldSpiderCard className="mt-4 d-flex flex-wrap align-items-center row-gap-3">
						{renderSpiderCards()}
					</XShieldSpiderCard>
				</XShieldRightScrollCard>
			</div>
		</>
	);
};

export default VAPayerComparisonDetails;
